<div *ngIf="!missingAttestation">
  <h3 class="hipaa-header" data-test="attestation-notice-header-text">
    Privacy and terms of service
  </h3>
  <p class="important-info-text" data-test="attestations-paragraph-text">
    Please read and understand these documents&mdash;they outline how SonderMind uses your account information,
    protects your privacy, and processes and collects payment from you and your insurer.
  </p>
  <form [formGroup]="setupForm">
    <iris-checkbox
      formControlName="agreedHipaa"
      *ngIf="hipaaAttestation"
      data-test="checkbox-hipaa-agreements"
    >
      I acknowledge that I have reviewed and understand my rights
      and responsibilities described in the
      <a
        class="attestation-link"
        [href]="hipaaAttestation.documentUrl"
        target="_blank"
        data-test="hipaa-notice-link-text"
      >SonderMind HIPAA Notice of Privacy Practices</a>.
    </iris-checkbox>

    <iris-checkbox
      formControlName="agreedTos"
      *ngIf="tosAttestation"
      data-test="checkbox-tos-agreements"
    >
      I agree to the
        <a
          class="attestation-link"
          [href]="tosAttestation.documentUrl"
          target="_blank"
          data-test="tos-notice-link-text"
        >Terms of Service.</a>
    </iris-checkbox>
  </form> 
</div>
<sonder-success-error-banner
  *ngIf="missingAttestation"
  [isSuccess]="false"
  [message]="missingAttestationText"
></sonder-success-error-banner>
